import React, { useState } from 'react'
import styled from 'styled-components'
import { breakpoint, getColor } from '../../shared/theme'
import Heading from '../../elements/typography/sectionHeading'
import ContentContainer from '../contentContainer'
import chevron from '../../assets/images/chevron-down.png'

const SectionWrapper = styled.section`
	padding: 46px 0 49px;

	@media ${breakpoint('tablet')} {
		padding: 69px 0 82px;
	}

	@media ${breakpoint('laptop')} {
		padding: 31px 0 126px;
		margin-top: 0px;
	}
`

const SectionHeader = styled.div`
	margin-bottom: 16px;

	@media ${breakpoint('tablet')} {
		margin-bottom: 28px;
	}
`

const SectionBody = styled.div``

const AccordionItem = styled.div`
	width: 100%;
	border-bottom: 1px solid ${getColor('black')};

	@media ${breakpoint('tablet')} {
		border-bottom: 2px solid ${getColor('black')};
	}
`

const AccordionHeader = styled.div`
	padding: 16px 0;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media ${breakpoint('tablet')} {
		padding: 30px 0;
	}
`

const AccordionCopy = styled.p`
	font-size: 10px;
	line-height: 12px;
	font-weight: 300;
	margin: 0;

	@media ${breakpoint('tablet')} {
		font-size: 18px;
		line-height: 21.6px;
	}
`

const AccordionBody = styled.div`
	max-height: ${(props) => (props.isOpen ? '300px' : '0')};
	overflow: hidden;
	transition: max-height 0.3s ease-in-out, padding-bottom 0.3s ease-in-out;
	padding-bottom: ${(props) => (props.isOpen ? '16px' : '0')};

	@media ${breakpoint('tablet')} {
		padding-bottom: ${(props) => (props.isOpen ? '30px' : '0')};
	}
`

const AccordionIcon = styled.img`
	width: 7.2px;
	height: 4.4px;
	margin: 0 15px;

	@media ${breakpoint('tablet')} {
		width: 13px;
		height: 8px;
		margin: 0 25px;
	}
`

export const FAQs = ({ heading, faqs }) => {
	const [openIndices, setOpenIndices] = useState([])

	const handleAccordionClick = (index) => {
		// Check if the index is already in the openIndices array
		if (openIndices.includes(index)) {
			// If it is, remove it
			setOpenIndices(openIndices.filter((i) => i !== index))
		} else {
			// If it is not, add it
			setOpenIndices([...openIndices, index])
		}
	}

	return (
		<SectionWrapper>
			<ContentContainer>
				<SectionHeader>
					<Heading>{heading && heading}</Heading>
				</SectionHeader>

				<SectionBody>
					{faqs &&
						faqs.map((faq, index) => {
							return (
								<AccordionItem key={index}>
									<AccordionHeader
										onClick={() => handleAccordionClick(index)}
										isOpen={openIndices.includes(index)}
									>
										<AccordionCopy>{faq.question}</AccordionCopy>
										<AccordionIcon
											src={chevron}
											style={{
												transform: `rotate(${
													openIndices.includes(index) ? '180deg' : '0deg'
												})`,
											}}
										/>
									</AccordionHeader>
									<AccordionBody isOpen={openIndices.includes(index)}>
										<AccordionCopy>{faq.answer}</AccordionCopy>
									</AccordionBody>
								</AccordionItem>
							)
						})}
				</SectionBody>
			</ContentContainer>
		</SectionWrapper>
	)
}

export default FAQs
